import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export const HAPPINESS_TIPS_CATEGORIES_MODULE = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
